<template>
  <vs-row>
    <vs-col
       vs-lg="12" vs-type="flex" class="pt-2 border-top"
    >
      <vs-chip
        data-cy="she-is-a-mother"
        v-if="file.estadoCodigoEstadoComprador === 1"
        v-tooltip="'Es Documento Madre'"
      >
        <vs-avatar icon="supervisor_account" color="#8633FF" />
        Madre
      </vs-chip>
      <vs-chip
        data-cy="Is-son"
        v-if="file.estadoCodigoEstadoComprador === 0"
        v-tooltip="'Es Documento Hijo'"
      >
        <vs-avatar icon="child_friendly" color="#8633FF" />
        Hijo
      </vs-chip>
      <vs-chip
        v-if="file.plazo > 0"
        v-tooltip="'Adhesiones'"
      >
        <vs-avatar icon="thumb_up" color="#02A52A" />
        {{ file.plazo }}
      </vs-chip>
      <vs-chip
        data-cy="File-update-date"
        class="mr-4" v-tooltip="'Fecha de actualización del Expediente'">
        <vs-avatar icon="date_range" />
        {{ file.fechaActualizacion | dateFormat }}
      </vs-chip>
      <vs-chip
        data-cy="File-creation-date"
        class="mr-4"
        v-tooltip="'Fecha de creación del expediente'"
      >
        <vs-avatar icon="date_range" />
        {{ file.fechaCreacion | dateFormat }}
      </vs-chip>
      <vs-chip
        data-cy="responsible"
        v-if="isAguasAndinas && responsible && onPendingFiles"
        class="mr-4"
        v-tooltip="'Responsable'"
      >
        <vs-avatar icon="person" color="#FF0000"/>
        {{ responsible.destinoListaNombre }}
      </vs-chip>
      <vs-chip
          v-if="isAguasAndinas && file.despachoCodigo"
          class="mr-4"
          v-tooltip="'Empresa'"
          data-cy="company-code"
      >
        <vs-avatar icon="event" color="#FF0000"/>
        {{ file.despachoCodigo }}
      </vs-chip>
      <vs-chip
        data-cy="expiration-date"
        v-if="isAguasAndinas && file.fechaVencimiento"
        class="mr-4"
        v-tooltip="'Fecha de vencimiento'"
      >
        <vs-avatar icon="event" color="#FF0000"/>
        {{ file.fechaVencimiento | dateFormat }}
      </vs-chip>
      <vs-chip
        data-cy="theme"
        v-if="isAguasAndinas && theme && onPendingFiles"
        class="mr-4"
        v-tooltip="'Tema'"
      >
        <vs-avatar icon="info" color="#FF0000"/>
        {{ theme.label }}
      </vs-chip>
      <vs-chip
        data-cy="document-date"
        v-if="file.fechaEmision"
        class="mr-4"
        v-tooltip="'Fecha del documento'"
      >
        <vs-avatar icon="event" color="#ff9f43"/>
        {{ file.fechaEmision | dateFormat }}
      </vs-chip>
      <vs-chip
        data-cy="Document-number"
        class="mr-3"
        v-tooltip="'Número de documento'"
        v-if="file.numeroInt  && !isAguasAndinas"
      >
        <vs-avatar icon="tag" color="#ff9f43" />
        {{file.numeroInt}}
      </vs-chip>
      <vs-chip
        data-cy="Document-number"
        class="mr-3"
        v-tooltip="'Número de documento'"
        v-if="file.numeroInt && isAguasAndinas"
      >
        <vs-avatar icon="tag" color="#003287" />
        {{file.numeroInt}}
      </vs-chip>

      <vs-chip
          data-cy="Document-number"
          class="mr-3"
          v-tooltip="'Número de documento en libreria'"
          v-if="file.nc_DOCNUM  && isAguasAndinas"
      >
        <vs-avatar icon="tag" color="#ff9f43" />
        {{file.nc_DOCNUM}}
      </vs-chip>
      <vs-chip
        class="mr-3"
        v-if="(file.emisorSucursalDireccion || file.emisorCentroCostoNombre) && !isUseExternalForm"
      >
        <vs-avatar icon="description" color="#ff9f43" />
        <span
          v-tooltip="`${file.emisorSucursalDireccion}`"
          v-if="file.emisorSucursalDireccion"
        >
          {{file.emisorSucursalDireccion | truncate(20)}}
        </span>
        <span
          v-tooltip="`${file.emisorCentroCostoNombre}`"
          v-if="!file.emisorSucursalDireccion"
        >
          {{(file.emisorCentroCostoNombre ||'')| truncate(20)}}
        </span>
      </vs-chip>
      <vs-chip
        data-cy="private-file"
        class="mr-3"
        v-tooltip="'archivo privado'"
        v-if="file.transportePuertoTipo == 1 && !isAguasAndinas"
        color="warning" transparent
      >
        <vs-avatar icon="lock" />
        privado
      </vs-chip>
      <vs-chip
        data-cy="reserved"
        class="mr-3"
        v-tooltip="'archivo reservado'"
        v-if="file.transportePuertoTipo == 2 && !isAguasAndinas"
        color="warning" transparent
      >
        <vs-avatar icon="description" />
        reservado
      </vs-chip>
      <vs-chip
        data-cy="public"
        class="mr-3"
        v-tooltip="'archivo público'"
        v-if="file.transportePuertoTipo == 0 && !isAguasAndinas"
        color="warning" transparent
      >
        <vs-avatar icon="lock" />
        público
      </vs-chip>
      <vs-chip
        class="mr-3"
        v-tooltip="'Enviado a Librería'"
        v-if="file.enviadoOpenText && file.enviadoOpenText === 'Y'"
        color="danger" transparent
      >
        <vs-avatar icon="trending_up" />
        enviado
      </vs-chip>
      <vs-chip
        data-cy="external"
        class="mr-3"
        v-tooltip="'Documento externo'"
        v-if="file.claseMercadoPublico === 'ext' && !isAguasAndinas"
        color="primary" transparent
      >
        externo
      </vs-chip>
      <vs-chip
        data-cy="internal"
        class="mr-3"
        v-tooltip="'Documento interno'"
        v-if="file.claseMercadoPublico === 'int' && !isAguasAndinas"
        color="primary" transparent
      >
        interno
      </vs-chip>
      <vs-chip
        data-cy="internal-numbering"
        class="mr-3"
        v-tooltip="'Numeración Interna'"
        v-if="file.claseMercadoPublico === 'numInt' && !isAguasAndinas"
        transparent color="primary"
      >
        num. interna
      </vs-chip>
      <vs-chip
        data-cy="official-numbering"
        class="mr-3"
        v-tooltip="'Numeración Oficina de Partes'"
        v-if="file.claseMercadoPublico === 'numOf' && !isAguasAndinas"
        color="primary" transparent
      >
        num. oficial
      </vs-chip>
      <vs-chip
        data-cy="copy"
        class="mr-3"
        v-tooltip="'Estoy en copia'"
        v-if="file.enCopia === 'SI'"
        color="success" transparent
      >
        copia
      </vs-chip>
      <vs-chip
        data-cy="responsible"
        class="mr-3"
        v-tooltip="'Soy destinatario/responsable'"
        v-if="file.enResponsable === 'SI' && onGeneralFiles"
        color="danger" transparent
      >
        responsable
      </vs-chip>
      <vs-chip
        data-cy="requiere-gestion"
        v-tooltip="'Requiere respuesta'"
        v-if="isAguasAndinas
          && responsible
          && !onGeneralFiles
          && file.receptorTelefono == '1'"
        color="info"
        transparent
      >
        <vs-avatar color="orange" icon="book" />
      </vs-chip>
      <vs-chip
        data-cy="is-knowledge"
        v-tooltip="'Para conocimiento'"
        v-if="isAguasAndinas
          && esConocimiento
          && !onGeneralFiles"
        color="info"
        transparent
      >
        <vs-avatar color="purple" icon="book" />
      </vs-chip>
      <vs-chip
        data-cy="in-a-group"
        class="mr-3"
        v-tooltip="'Estoy en grupo'"
        v-if="file.enGrupo === 'SI'"
        color="danger" transparent
      >
        en grupo
      </vs-chip>
      <vs-chip
        data-cy="physical"
        class="mr-3"
        v-tooltip="'Acompaña físico'"
        v-if="file.transporteViaTransporteCodigoTransporte === 1 && !isAguasAndinas"
        color="#343a40" transparent
      >
        <vs-avatar icon="description" />
        físico
      </vs-chip>

    </vs-col>
  </vs-row>
</template>
<script>
import { mapGetters } from 'vuex';

import Themes from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/Themes';
import { GORE_VALPARAISO, SERCOTEC, SISS } from '@/constants/companies';
import ProvidencesTypes from '@/febos/chile/dnt/mixins/ProvidencesTypes';

export default {
  data() {
    return {
      dataDueDate: true
    };
  },
  props: [
    'file',
    'onGeneralFiles',
    'onPendingFiles'
  ],
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company']),
    isUseExternalForm() {
      return [GORE_VALPARAISO.iut, SISS.iut, SERCOTEC.iut].includes(this.company.iut);
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    responsible() {
      const subjectResponsible = 1;
      const subject = this.file && (this.file.destinatarios || [])
        .find((person) => person.tipoDestino === subjectResponsible && person.estado === 1);
      return subject || {};
    },
    esConocimiento() {
      const subject = this.file && (this.file.destinatarios || [])
        .some((person) => parseInt(person.providenciaId, 10) === ProvidencesTypes.KNOWLEDGE
          && person.estado === 1);
      return subject;
    },
    theme() {
      const themeFile = Themes
        .find((theme) => theme.tema.id === this.file.transporteEmpresaTransporteInfoAdicional);
      return (themeFile && themeFile.tema) || {};
    },
    dueDate() {
      const subjectResponsible = 1;
      const fnd = (this.file.destinatarios || [])
        .find((el) => el.tipoDestino === subjectResponsible && el.estado === 1)
        || {};
      if (fnd.providenciaVencimiento) {
        return fnd.providenciaVencimiento;
      }
      // eslint-disable-next-line
      this.dataDueDate = false;
      return '-';
    }
  }
};
</script>
